// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__wl5Na","open":"styles_open__PaSeW","wrapper":"styles_wrapper__zqljV","box":"styles_box__ImY6w"};